var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:[_vm.data.type, _vm.activeClass]},[_c('button',{staticClass:"delete",on:{"click":_vm.close}}),_c('p',{staticClass:"has-text-white is-marginless",domProps:{"innerHTML":_vm._s(_vm.data.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }